var React = require('react');

function UpgradeInsurance (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5 35c-.205 0-.409-.056-.59-.167l-.124-.076C-.195 25.638.572 5.818.612 4.979a1.129 1.129 0 011.127-1.075h.009l.22.001c7.04 0 11.271-2.53 12.765-3.617.156-.115.394-.288.767-.288.374 0 .612.173.769.288 1.493 1.088 5.726 3.617 12.763 3.617l.221-.001a1.111 1.111 0 011.135 1.075c.04.84.807 20.659-14.177 29.781l-.12.074c-.182.11-.386.166-.591.166zm-.804-7.823c-.286 0-.572-.108-.792-.325-2.968-2.926-5.164-6.741-6.528-11.341a1.13 1.13 0 012.164-.642c1.254 4.23 3.255 7.721 5.948 10.375a1.129 1.129 0 01-.792 1.933zM2.861 6.149c.07 4.102 1.136 19.018 12.639 26.393 11.504-7.378 12.569-22.291 12.638-26.393C21.675 5.962 17.448 3.785 15.5 2.5 13.551 3.785 9.325 5.962 2.861 6.149z"}));
}

UpgradeInsurance.defaultProps = {"width":"31","height":"35","viewBox":"0 0 31 35"};

module.exports = UpgradeInsurance;

UpgradeInsurance.default = UpgradeInsurance;
